<!--
<div class="router-outlet-div" [@triggerName]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
-->

<router-outlet></router-outlet>
